import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Drawer, Form, Input, InputNumber, Icon, notification, Tooltip, Upload, Modal, Progress } from "antd";
import HTMLEllipsis from "react-lines-ellipsis/lib/html";
import axios from "axios";
import { Upload as UploadVimeo } from "tus-js-client";
import { GlobalContext } from "../../../../../app/providers/GlobalState";
import DrawerHTML from "./DrawerHTML";

import { htmlToPlainText, FormatWithEllipsis } from "../../../../../shared/utils/htmlTexteConverter";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const accessToken = "c25f3d22c7bcd79d2044ad6eb33ea514";

const headerPost = {
    Accept: "application/vnd.vimeo.*+json;version=3.4",
    Authorization: `bearer ${accessToken}`,
    "Content-Type": "application/json"
};

class DrawerArtigo extends Component {
    static contextType = GlobalContext;
    state = {
        titulo: "",
        texto: "",
        //VIDEO
        videoId: "",
        transcricao: "",
        video: [],
        ordem: 1,
        //PROGRESS
        upload_progress: 0,
        //LOADING
        iconLoading: false,
        //DRAWER HTML
        drawerHTMLVisible: false,
        drawerTranscricaoVisible: false
    };

    UNSAFE_componentWillMount() {}

    handlerChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    handlerChangeOrdem = ordem => {
        this.setState({
            ordem
        });
    };

    handlerChangeRadio = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    handleChangeEditor = texto => {
        this.setState({
            html_status: "",
            html_help: "",
            texto
        });
    };

    handleChangeColorPickerFundo = (color, event) => {
        this.setState({
            corFundo: color.hex
        });
    };

    handleChangeColorPickerFonte = (color, event) => {
        this.setState({
            corFonte: color.hex
        });
    };

    carregar = id => {
        axios({
            method: "get",
            url: "/api/empresa/carregar-faq-resposta",
            params: {
                id
            }
        })
            .then(response => {
                var video = [];

                if (response.data.video)
                    video.push({
                        uid: "-1",
                        name: response.data.video_nome,
                        status: "done"
                    });

                this.setState({
                    titulo: response.data.pergunta,
                    texto: response.data.resposta,
                    video,
                    videoId: response.data.video,
                    transcricao: response.data.transcricao,
                    ordem: response.data.ordem
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar o artigo!");

                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    criarInfo = () => {
        if (this.state.video.length) {
            this.criarVideoVimeo();
        } else {
            this.criar();
        }
    };

    criarVideoVimeo = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err && htmlToPlainText(this.state.texto)) {
                this.setState({ iconLoading: true });

                const file = this.state.video[0];
                const fileName = file.name;
                const fileSize = file.size.toString();

                axios({
                    method: "post",
                    url: `https://api.vimeo.com/me/videos`,
                    headers: headerPost,
                    data: {
                        upload: {
                            status: "in_progress",
                            approach: "tus",
                            size: fileSize
                        },
                        name: this.state.titulo.trim(),
                        privacy: { view: "disable" }
                    }
                }).then(response => {
                    this.uploadVimeo(file, response);
                });
            } else {
                if (!htmlToPlainText(this.state.texto))
                    this.setState({
                        html_status: "error",
                        html_help: "Campo obrigatório"
                    });
            }
        });
    };

    uploadVimeo = (file, response) => {
        const upload = new UploadVimeo(file, {
            endPoint: "https://api.vimeo.com/me/videos",
            uploadUrl: response.data.upload.upload_link,
            retryDelays: [0, 3000, 5000, 10000, 20000],
            metadata: {
                filename: file.name,
                filetype: file.type
            },
            headers: {},
            onError: error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível criar o registo!");
            },
            onProgress: (bytesUploaded, bytesTotal) => {
                let percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(1);

                this.setState({
                    upload_progress: percentage
                });
            },
            onSuccess: () => {
                var videoId = response.data.link.split("/").pop();
                this.moverParaPasta(videoId);
                this.adicionarDominioEPreset(videoId);
                this.criar(videoId, file.name);
            }
        });

        upload.start();
    };

    moverParaPasta = videoId => {
        axios({
            method: "put",
            url: `https://api.vimeo.com/me/projects/${this.context.albumId_entidade}/videos/${videoId}`,
            headers: headerPost
        });
    };

    adicionarDominioEPreset = videoId => {
        axios({
            method: "get",
            url: "/api/curso/carregar-vimeo-configs"
        }).then(response => {
            this.adicionarPreset(videoId, response.data.presetId);
            this.adicionarDominio(videoId, response.data.dominio);
        });
    };

    adicionarPreset = (videoId, presetId) => {
        axios({
            method: "put",
            url: `https://api.vimeo.com/videos/${videoId}/presets/${presetId}`,
            headers: headerPost
        });
    };

    adicionarDominio = (videoId, dominio) => {
        axios({
            method: "put",
            url: `https://api.vimeo.com/videos/${videoId}/privacy/domains/${dominio}`,
            headers: headerPost
        });
    };

    criar = (videoId, videoNome) => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err && htmlToPlainText(this.state.texto)) {
                this.setState({
                    iconLoading: true
                });

                var item = new FormData();
                item.append("id_subgrupo", this.props.paginaId);
                item.append("pergunta", this.state.titulo);
                item.append("resposta", this.state.texto);
                if (videoId) {
                    item.append("video", videoId);
                    item.append("video_nome", videoNome);
                }
                if (this.state.transcricao) item.append("transcricao", this.state.transcricao);
                item.append("ordem", this.state.ordem);

                axios({
                    method: "post",
                    url: "/api/empresa/adicionar-faq-resposta",
                    data: item
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", "Ação efetuada com sucesso!");
                        this.setState(
                            {
                                iconLoading: false
                            },
                            () => this.props.atualizarRegisto()
                        );
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível adicionar o registo!");
                        this.setState({
                            iconLoading: false
                        });
                    });
            } else {
                if (!htmlToPlainText(this.state.texto))
                    this.setState({
                        html_status: "error",
                        html_help: "Campo obrigatório"
                    });
            }
        });
    };

    alterarInfo = () => {
        if (this.state.video.length) {
            this.alterarVideoVimeo();
        } else {
            this.alterar();
        }
    };

    alterarVideoVimeo = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err && htmlToPlainText(this.state.texto)) {
                this.setState({ iconLoading: true });

                if (this.state.video[0].status === "done") {
                    this.alterar(this.state.videoId, this.state.video[0].name);
                } else {
                    const file = this.state.video[0];
                    const fileName = file.name;
                    const fileSize = file.size.toString();

                    axios({
                        method: "post",
                        url: `https://api.vimeo.com/me/videos`,
                        headers: headerPost,
                        data: {
                            upload: {
                                status: "in_progress",
                                approach: "tus",
                                size: fileSize
                            },
                            name: this.props.tituloAula.trim(),
                            privacy: { view: "disable" }
                        }
                    }).then(response => {
                        this.alterarUploadVimeo(file, response);
                    });
                }
            } else {
                if (!htmlToPlainText(this.state.texto))
                    this.setState({
                        html_status: "error",
                        html_help: "Campo obrigatório"
                    });
            }
        });
    };

    alterarUploadVimeo = (file, response) => {
        const upload = new UploadVimeo(file, {
            endPoint: `https://api.vimeo.com/videos/${this.props.recurso}/versions`,
            uploadUrl: response.data.upload.upload_link,
            retryDelays: [0, 3000, 5000, 10000, 20000],
            metadata: {
                filename: file.name,
                filetype: file.type
            },
            headers: {},
            onError: error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível criar tarefa!");
            },
            onProgress: (bytesUploaded, bytesTotal) => {
                let percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(1);

                this.setState({
                    upload_progress: percentage
                });
            },
            onSuccess: () => {
                this.removerVideoVimeoAnterior(this.state.videoId);
                var videoId = response.data.link.split("/").pop();
                this.moverParaPasta(videoId, file.name);
                this.adicionarDominioEPreset(videoId);
                this.alterar(videoId, file.name);
                //this.setState({
                //    imagem: "",
                //    preview: null,
                //})
            }
        });

        upload.start();
    };

    removerVideoVimeoAnterior = videoId => {
        axios({
            method: "delete",
            url: `https://api.vimeo.com/videos/${videoId}`,
            headers: headerPost
        });
    };

    removerVideoVimeoErro = videoId => {
        axios({
            method: "delete",
            url: `https://api.vimeo.com/videos/${videoId}`,
            headers: headerPost
        });
    };

    alterar = (videoId, videoNome) => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err && htmlToPlainText(this.state.texto)) {
                this.setState({
                    iconLoading: true
                });

                var item = new FormData();
                item.append("id", this.props.infoId);
                item.append("pergunta", this.state.titulo);
                item.append("resposta", this.state.texto);
                if (videoId) {
                    item.append("video", videoId);
                    item.append("video_nome", videoNome);
                }
                if (this.state.transcricao) item.append("transcricao", this.state.transcricao);
                item.append("ordem", this.state.ordem);

                axios({
                    method: "post",
                    url: "/api/empresa/alterar-faq-resposta",
                    data: item
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", "Ação efetuada com sucesso!");
                        this.setState(
                            {
                                iconLoading: false
                            },
                            () => this.props.atualizarRegisto()
                        );
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível alterar o registo!");
                        this.setState({
                            iconLoading: false
                        });
                    });
            } else {
                if (!htmlToPlainText(this.state.texto))
                    this.setState({
                        html_status: "error",
                        html_help: "Campo obrigatório"
                    });
            }
        });
    };

    validarFormatos = (formato, formatos_aceites) => {
        var valido = false;

        for (var i = 0; i < formatos_aceites.length; i++) {
            if (formato === formatos_aceites[i]) valido = true;
        }

        return valido;
    };

    //MP4, MOV, WMV, AVI e FLV - Video
    validar = (rule, value, callback) => {
        if (value.file)
            if (
                !this.validarFormatos(value.file.name.split(".").pop().toLowerCase(), ["mp4", "mov", "wmv", "avi", "flv"]) ||
                value.file.size > 5368709120
            )
                callback("Campo obrigatório");

        callback();
    };

    afterVisibleChange = aberto => {
        if (aberto) {
            this.props.form.resetFields();
            if (this.props.infoId) {
                this.carregar(this.props.infoId);
            } else {
                this.setState({
                    titulo: "",
                    texto: "",
                    //VIDEO
                    videoId: "",
                    transcricao: "",
                    video: [],
                    ordem: this.props.ordem,
                    //PROGRESS
                    upload_progress: 0,
                    //LOADING
                    iconLoading: false,
                    //DRAWER HTML
                    drawerHTMLVisible: false,
                    drawerTranscricaoVisible: false
                });
            }
        }
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const Dragger = Upload.Dragger;
        const {
            titulo,
            texto,
            //VIDEO
            videoId,
            transcricao,
            video,
            ordem,
            //PROGRESS
            upload_progress,
            //LOADING
            iconLoading,
            //DRAWER HTML
            drawerHTMLVisible,
            drawerTranscricaoVisible
        } = this.state;

        const { ativo, infoId, visible } = this.props;

        const propsVideo = {
            accept: ".mp4, .mov, .wmv, .avi, .flv",
            multiple: false,
            onRemove: file => {
                this.props.form.resetFields("video");
                this.setState({
                    video: []
                });
            },
            defaultFileList: this.state.video,
            beforeUpload: file => {
                if (!this.validarFormatos(file.name.split(".").pop().toLowerCase(), ["mp4", "mov", "wmv", "avi", "flv"])) {
                    openNotificationWithIcon("error", "Erro", "Ficheiro com formato inválido");
                    return false;
                }

                if (file.size > 5368709120) {
                    openNotificationWithIcon("error", "Erro", "Limite de 5 GB por upload");
                    return false;
                }

                this.setState(state => ({
                    video: [file]
                }));

                return false;
            },
            video
        };

        const textHtmlConverted = htmlToPlainText(texto);
        const transcriptionHtmlConverted = htmlToPlainText(transcricao);

        return (
            <Drawer
                className="drawer-pagina-informacoes"
                width={720}
                onClose={this.props.onClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={this.afterVisibleChange}
            >
                <div className="bloco-info">
                    <Form className="form-categorias" layout="horizontal">
                        <div className="bloco">
                            <Form.Item label="Pergunta">
                                {getFieldDecorator("titulo", {
                                    rules: [{ required: true, message: "Campo obrigatório" }],
                                    initialValue: titulo
                                })(<Input name="titulo" disabled={!ativo} onChange={this.handlerChange} />)}
                            </Form.Item>
                            <Form.Item label="Resposta" validateStatus={this.state.html_status} help={this.state.html_help}>
                                {ativo && (
                                    <Link
                                        to="#"
                                        className="link-principal"
                                        style={{ paddingLeft: 0 }}
                                        onClick={() => this.setState({ drawerHTMLVisible: true })}
                                    >
                                        {textHtmlConverted ? "Editar" : "Adicionar"}
                                    </Link>
                                )}
                                {textHtmlConverted && <p style={{ lineHeight: "normal" }}>{FormatWithEllipsis(textHtmlConverted, 100)}</p>}
                            </Form.Item>
                            <Form.Item label="Video (MP4, MOV, WMV, AVI, FLV)">
                                <Dragger {...propsVideo} fileList={this.state.video} disabled={this.state.imagem || !ativo}>
                                    <p className="ant-upload-drag-icon">
                                        <i className="fas fa-upload" />
                                    </p>
                                    <p className="ant-upload-text">
                                        Adicionar anexo{" "}
                                        <Tooltip title="Formatos válidos: .mp4, .mov, .wmv, .avi, .flv">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </p>
                                    <p className="ant-upload-hint">Limite de 5GB por upload</p>
                                </Dragger>
                            </Form.Item>
                            <Form.Item label="Transcrição">
                                {ativo && (
                                    <Link
                                        to="#"
                                        className="link-principal"
                                        style={{ paddingLeft: 0 }}
                                        onClick={() => this.setState({ drawerTranscricaoVisible: true })}
                                    >
                                        {transcriptionHtmlConverted ? "Editar" : "Adicionar"}
                                    </Link>
                                )}
                                {transcriptionHtmlConverted && (
                                    <p style={{ lineHeight: "normal" }}>
                                        {FormatWithEllipsis(htmlToPlainText(transcriptionHtmlConverted), 100)}
                                    </p>
                                )}
                            </Form.Item>
                            <Form.Item label="Ordem">
                                {getFieldDecorator("ordem", {
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ],
                                    initialValue: ordem
                                })(
                                    <InputNumber
                                        className="input-25"
                                        name="ordem"
                                        min={1}
                                        disabled={!ativo}
                                        onChange={this.handlerChangeOrdem}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </Form>
                </div>
                <div className="ant-drawer-footer">
                    <Link
                        to="#"
                        className="botao-secundario"
                        onClick={this.props.onClose}
                        style={{ marginRight: 20, display: "inline-block" }}
                    >
                        Voltar
                    </Link>
                    {ativo && (
                        <button className="botao-principal" disabled={iconLoading} onClick={infoId ? this.alterarInfo : this.criarInfo}>
                            {iconLoading ? <Icon type="loading" /> : null}
                            Salvar
                        </button>
                    )}
                </div>
                <DrawerHTML
                    texto={texto}
                    visible={drawerHTMLVisible}
                    onClose={() => this.setState({ drawerHTMLVisible: false })}
                    handleChangeEditor={this.handleChangeEditor}
                />
                <DrawerHTML
                    texto={transcricao}
                    visible={drawerTranscricaoVisible}
                    onClose={() => this.setState({ drawerTranscricaoVisible: false })}
                    handleChangeEditor={transcricao => this.setState({ transcricao })}
                />
                <Modal
                    visible={iconLoading && video.length > 0}
                    maskClosable={false}
                    className="modal-loading"
                    footer={null}
                    closable={false}
                >
                    <div className="modal-loading-bloco">
                        <p>
                            <Progress type="circle" percent={Number(upload_progress)} />
                        </p>
                        <p className="texto">A enviar...</p>
                    </div>
                </Modal>
            </Drawer>
        );
    }
}
const FormDrawerArtigo = Form.create({ name: "form-drawer-artigo" })(DrawerArtigo);

export default FormDrawerArtigo;
